import React from 'react'
import { isFeatureEnabled } from '../utils/remote-config'
import { Message } from '@paypalcorp/worldready-react'
import { sharedInfoConfig } from './data-privacy-data-platform'
import { pageSpec } from './fptiConstants'

function getFeatureFlags(serverData) {
  const isMerchantUser = serverData.isMerchantUser ?? false
  const enabledForPermission =
    !isMerchantUser &&
    isFeatureEnabled('enabledForPermission') &&
    isFeatureEnabled('enabledForRecommendations')
  const enabledForRecommendations =
    !isMerchantUser && isFeatureEnabled('enabledForRecommendations')
  const enabledForManageSharedInfoSection =
    enabledForPermission || enabledForRecommendations
  return {
    isMerchantUser,
    enabledForPermission,
    enabledForRecommendations,
    enabledForManageSharedInfoSection,
  }
}
const linkClassName = 'nemo-subSection-header subSection-header'
function sharedInfoSections(serverData) {
  const featureFlags = getFeatureFlags(serverData)
  return [
    {
      sectionId: 'sharedInfoSection',
      sectionName: <Message id="privacy.sharedInfo.sectionName" />,
      isEnabled: featureFlags.enabledForManageSharedInfoSection,
      enabledCountries: [],
      hasElmoTreatment: true,
      subSections: [
        {
          subSectionId: 'permissions',
          title: <Message id="privacy.permissions.title" />,
          desc: <Message id="privacy.permissions.desc" />,
          icon: sharedInfoConfig.permission.icon,
          linkClass: linkClassName,
          hasElmoTreatment: true,
          featureEnabled: featureFlags.enabledForPermission, //rcs service
          navigateTo:
            '/myaccount/security/flow/permissions/thirdparty?flow=cmV0dXJuVXJsPS9teWFjY291bnQvcHJpdmFjeSZjYW5jZWxVcmw9L215YWNjb3VudC9wcml2YWN5',
          fptiClickData: pageSpec.privacy_sections_permissions_given_Link(),
        },
        {
          subSectionId: 'recommendtations',
          title: <Message id="privacy.recommendations.title" />,
          desc: <Message id="privacy.recommendations.desc" />,
          icon: sharedInfoConfig.recommendations.icon,
          linkClass: linkClassName,
          hasElmoTreatment: true,
          featureEnabled: featureFlags.enabledForRecommendations, //rcs service
          navigateTo: '/myaccount/privacy/settings/recommendations',
          fptiClickData: pageSpec.privacy_section_shared_recommendations_link(),
        },
      ],
    },
  ]
}

export default sharedInfoSections
